/* LARTESTUDIO · Nova home · movimento
   Funciona com o editor de temas da Shopify (shopify:section:load). */
(function () {
  if (window.__ltHome) return;
  window.__ltHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revelar ao rolar: só marca como pendente o que está abaixo da tela */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-lt-reveal]');
    if (!('IntersectionObserver' in window) || reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('is-pending'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight * 0.92) {
        el.classList.add('is-pending');
        io.observe(el);
      }
    });
  }

  /* Hero: troca de ambientes + palavra que gira */
  function initHero(root) {
    root.querySelectorAll('[data-lt-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('.lt-hero__slide');
      var cards = hero.querySelectorAll('.lt-hero__card');
      var dots = hero.querySelectorAll('.lt-hero__dots button');
      var ms = parseInt(hero.getAttribute('data-ms'), 10) || 6000;
      hero.style.setProperty('--lt-slide-ms', ms + 'ms');
      var i = 0, timer;
      function go(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        [slides, cards, dots].forEach(function (list) {
          list.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        });
        clearTimeout(timer);
        if (!reduce && slides.length > 1) timer = setTimeout(function () { go(i + 1); }, ms);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      go(0);

      var words = hero.querySelectorAll('.lt-hero__rot span');
      if (words.length > 1 && !reduce) {
        var w = 0;
        setInterval(function () {
          var cur = words[w];
          cur.classList.remove('is-on'); cur.classList.add('is-off');
          w = (w + 1) % words.length;
          var nxt = words[w];
          nxt.classList.remove('is-off');
          void nxt.offsetWidth;
          nxt.classList.add('is-on');
          setTimeout(function () { cur.classList.remove('is-off'); }, 900);
        }, 2600);
      }
    });
  }

  /* Faixa: duplica o conteúdo para o loop ficar contínuo */
  function initMarquee(root) {
    root.querySelectorAll('.lt-faixa__row').forEach(function (row) {
      if (row.dataset.ltDone) return;
      row.dataset.ltDone = '1';
      var html = row.innerHTML, n = 1;
      while (row.scrollWidth < window.innerWidth && n < 8) { row.insertAdjacentHTML('beforeend', html); n++; }
      row.insertAdjacentHTML('beforeend', row.innerHTML);
    });
  }

  /* Coleções: arrastar com o mouse + setas */
  function initTrack(root) {
    root.querySelectorAll('[data-lt-track]').forEach(function (track) {
      var sec = track.closest('section') || root;
      var step = function () { return track.clientWidth * 0.8; };
      sec.querySelectorAll('[data-lt-prev]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      sec.querySelectorAll('[data-lt-next]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
      var down = false, x0 = 0, s0 = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - x0;
        if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        track.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () { down = false; track.classList.remove('is-drag'); });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* Compre por cor: o fundo da seção vira a cor escolhida */
  function initCores(root) {
    root.querySelectorAll('[data-lt-cores]').forEach(function (sec) {
      var word = sec.querySelector('.lt-cores__word');
      var base = word ? word.textContent : '';
      var chips = sec.querySelectorAll('.lt-chip');
      function paint(chip) {
        chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        if (!chip) { sec.style.removeProperty('--lt-cor'); sec.classList.remove('is-dark'); if (word) word.textContent = base; return; }
        sec.style.setProperty('--lt-cor', chip.getAttribute('data-hex'));
        sec.classList.toggle('is-dark', chip.getAttribute('data-dark') === 'true');
        if (word) word.textContent = chip.getAttribute('data-word') || chip.textContent.trim();
      }
      chips.forEach(function (c) {
        c.addEventListener('mouseenter', function () { paint(c); });
        c.addEventListener('focus', function () { paint(c); });
      });
      sec.addEventListener('mouseleave', function () { paint(null); });
    });
  }

  /* Vitrine com abas */
  function initTabs(root) {
    root.querySelectorAll('[data-lt-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.lt-tabs button');
      var panels = wrap.querySelectorAll('.lt-vit__panel');
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k); });
          panels.forEach(function (p, j) {
            p.hidden = j !== k;
            p.classList.remove('is-in');
            if (j === k) { void p.offsetWidth; p.classList.add('is-in'); }
          });
        });
      });
    });
  }

  /* Números que contam + parallax suave na consultoria */
  function initCounters(root) {
    var nums = root.querySelectorAll('[data-lt-count]');
    if (!nums.length) return;
    function run(el) {
      var end = parseFloat(el.getAttribute('data-lt-count'));
      if (reduce || isNaN(end)) return;
      var t0 = null, dur = 1400;
      function f(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(f);
      }
      el.textContent = '0';
      requestAnimationFrame(f);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }
  function initParallax(root) {
    var imgs = root.querySelectorAll('[data-lt-par]');
    if (!imgs.length || reduce) return;
    function tick() {
      imgs.forEach(function (box) {
        var r = box.getBoundingClientRect();
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        var img = box.querySelector('img');
        if (img) img.style.transform = 'scale(1.15) translateY(' + (p * -24).toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  function init(root) {
    root = root || document;
    initMarquee(root); initHero(root); initTrack(root); initCores(root);
    initTabs(root); initCounters(root); initParallax(root); initReveal(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
